import {BaseMobxStore} from "../../../../infrastructure/mobx/base-mobx-store";
import {MegaHeaderModuleConfig} from "./mega-header-module.config";
import {MegaHeaderModuleState} from "./models/mega-header-module.state";

export class MegaHeaderModuleStore extends BaseMobxStore {
  static injectables = [MegaHeaderModuleConfig, MegaHeaderModuleState];
}

